import { Skeleton } from 'antd';
import Title from 'antd/es/typography/Title';

import WidgetCard, { ActivityWidgetProps, WidgetTitle } from '../WidgetCard';
import { formatNumberWithComma, renderInfoValue } from 'utils/helpers';

export interface HotcashWidgetProps extends ActivityWidgetProps {
  amount: number;
  currency: string;
}

export const HotcashWidgetSkeleton = () => {
  return (
    <WidgetCard className="activity-widget activity-widget--hotcash">
      <Skeleton active title={false} paragraph={{ rows: 1, width: ['30%'] }} />
      <Skeleton active title={false} paragraph={{ rows: 1, width: ['50%'] }} />
    </WidgetCard>
  );
};

const HotcashWidget = ({ isLoading, currency, amount }: HotcashWidgetProps) => {
  if (isLoading) return <HotcashWidgetSkeleton />;

  return (
    <WidgetCard className="activity-widget activity-widget--hotcash">
      <WidgetTitle type="normal">Hot Cash</WidgetTitle>
      <Title
        ellipsis={{ tooltip: true }}
        level={2}
        className="m-0"
        style={{ lineHeight: '38px', maxWidth: '90%' }}
      >
        {renderInfoValue(
          `${formatNumberWithComma(amount)} ${amount <= 0 ? '' : currency}`,
        )}
      </Title>
    </WidgetCard>
  );
};

export default HotcashWidget;
